import { useState } from 'react';

const cities = [
  'Adana','Ankara','Antalya','Bursa','Diyarbakır','Eskişehir','Gaziantep',
  'Hatay','İstanbul','İzmir','Kayseri','Kocaeli','Konya','Malatya','Manisa',
  'Mersin','Samsun','Trabzon','Van','Şanlıurfa',
];

const countries = [
  { code: 'TR', name: 'Turkey', flag: '🇹🇷' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  { code: 'GB', name: 'UK', flag: '🇬🇧' },
  { code: 'US', name: 'USA', flag: '🇺🇸' },
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
  { code: 'AE', name: 'UAE', flag: '🇦🇪' },
];

const inputStyle: React.CSSProperties = {
  fontSize: 13,
  borderRadius: 8,
};

export default function PriceCalculator() {
  const [activeTab, setActiveTab] = useState<'hesapla' | 'takip'>('hesapla');
  const [packageType, setPackageType] = useState<'koli' | 'paket'>('koli');
  const [fromCountry, setFromCountry] = useState('Turkey');
  const [fromCity, setFromCity] = useState('');
  const [toCountry, setToCountry] = useState('Turkey');
  const [toCity, setToCity] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [weight, setWeight] = useState('');
  const [width, setWidth] = useState('');
  const [length, setLength] = useState('');
  const [height, setHeight] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [trackingNo, setTrackingNo] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<null | { price: number; vat: number }>(null);

  const handleCalculate = () => {
    if (!fromCity || !toCity || !weight) return;
    setIsLoading(true);
    setResult(null);
    setTimeout(() => {
      const base = parseFloat(weight) * 13.5 + (length && width && height ? (parseFloat(length) * parseFloat(width) * parseFloat(height)) / 5000 * 8 : 0);
      const price = Math.max(base, 25);
      setResult({ price, vat: price * 0.2 });
      setIsLoading(false);
    }, 1000);
  };

  const isValid = fromCity && toCity && weight;

  return (
    <div style={{ background: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-7">
        {/* Card */}
        <div
          className="rounded-2xl overflow-hidden"
          style={{
            background: 'var(--surface)',
            border: '2px solid var(--border2)',
            borderTop: '3px solid var(--orange)',
            boxShadow: '0 4px 24px rgba(232,97,26,0.08), 0 1px 4px rgba(0,0,0,0.06)',
          }}
        >
          {/* Tabs */}
          <div
            className="flex items-center gap-1 px-5 pt-4 pb-0"
            style={{ borderBottom: '1.5px solid var(--border)' }}
          >
            {(['hesapla', 'takip'] as const).map((tab) => {
              const active = activeTab === tab;
              return (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className="flex items-center gap-2 px-5 py-2.5 rounded-t-xl text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
                  style={{
                    background: active ? 'var(--orange)' : 'transparent',
                    color: active ? '#fff' : 'var(--text3)',
                    border: active ? '1.5px solid var(--orange)' : '1.5px solid transparent',
                    borderBottom: active ? '1.5px solid var(--surface)' : '1.5px solid transparent',
                    marginBottom: active ? -2 : 0,
                  }}
                >
                  <i className={tab === 'hesapla' ? 'ri-calculator-line' : 'ri-map-pin-line'}></i>
                  {tab === 'hesapla' ? 'Fiyat Hesapla' : 'Gönderi Takip'}
                </button>
              );
            })}
          </div>

          {/* Content */}
          <div className="p-5" style={{ background: 'var(--surface2)' }}>

            {/* ── TAKİP SEKMESI ── */}
            {activeTab === 'takip' && (
              <div className="flex items-center gap-3">
                <div className="flex-1">
                  <input
                    type="text"
                    placeholder="Takip numaranızı girin (örn: CN-28410)"
                    value={trackingNo}
                    onChange={(e) => setTrackingNo(e.target.value)}
                    className="inp"
                    style={{ ...inputStyle, fontSize: 14 }}
                  />
                </div>
                <button className="btn-primary whitespace-nowrap" style={{ padding: '12px 28px' }}>
                  <i className="ri-search-line"></i> Sorgula
                </button>
              </div>
            )}

            {/* ── HESAPLA SEKMESI ── */}
            {activeTab === 'hesapla' && (
              <div className="space-y-4">

                {/* Row 1 — Nereden / Nereye */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: 6 }}>
                      Nereden
                    </label>
                    <div className="flex gap-2">
                      <select value={fromCountry} onChange={(e) => setFromCountry(e.target.value)} className="inp" style={{ ...inputStyle, cursor: 'pointer', flex: '0 0 140px' }}>
                        {countries.map((c) => <option key={c.code} value={c.name}>{c.flag} {c.name}</option>)}
                      </select>
                      <select value={fromCity} onChange={(e) => setFromCity(e.target.value)} className="inp" style={{ ...inputStyle, cursor: 'pointer', flex: 1 }}>
                        <option value="">Şehir</option>
                        {cities.map((c) => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                  </div>

                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: 6 }}>
                      Nereye
                    </label>
                    <div className="flex gap-2">
                      <select value={toCountry} onChange={(e) => setToCountry(e.target.value)} className="inp" style={{ ...inputStyle, cursor: 'pointer', flex: '0 0 140px' }}>
                        {countries.map((c) => <option key={c.code} value={c.name}>{c.flag} {c.name}</option>)}
                      </select>
                      <select value={toCity} onChange={(e) => setToCity(e.target.value)} className="inp" style={{ ...inputStyle, cursor: 'pointer', flex: 1 }}>
                        <option value="">Şehir</option>
                        {cities.map((c) => <option key={c} value={c}>{c}</option>)}
                      </select>
                      <input type="text" placeholder="Posta Kodu" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} className="inp" style={{ ...inputStyle, flex: '0 0 110px' }} />
                    </div>
                  </div>
                </div>

                {/* Row 2 — Paket Türü + Boyutlar */}
                <div className="flex flex-wrap items-end gap-4">
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: 6 }}>
                      Paket Türü
                    </label>
                    <div className="flex gap-2">
                      {[
                        { id: 'koli', label: 'Koli', icon: 'ri-archive-line' },
                        { id: 'paket', label: 'Paket', icon: 'ri-box-3-line' },
                      ].map((t) => (
                        <button
                          key={t.id}
                          onClick={() => setPackageType(t.id as 'koli' | 'paket')}
                          className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
                          style={{
                            background: packageType === t.id ? 'rgba(232,97,26,0.15)' : 'var(--input-bg, var(--surface))',
                            border: packageType === t.id ? '1.5px solid var(--orange)' : '1.5px solid var(--border2)',
                            color: packageType === t.id ? 'var(--orange)' : 'var(--text2)',
                          }}
                        >
                          <i className={t.icon}></i>
                          {t.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="flex-1">
                    <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: 6 }}>
                      Boyutlar
                    </label>
                    <div className="flex gap-2 flex-wrap">
                      {[
                        { val: weight, set: setWeight, ph: 'Ağırlık (kg)', unit: 'kg' },
                        { val: width, set: setWidth, ph: 'Genişlik (cm)', unit: 'cm' },
                        { val: length, set: setLength, ph: 'Uzunluk (cm)', unit: 'cm' },
                        { val: height, set: setHeight, ph: 'Yükseklik (cm)', unit: 'cm' },
                      ].map((field, i) => (
                        <div key={i} className="relative" style={{ flex: '1 1 100px', minWidth: 90 }}>
                          <input
                            type="number"
                            placeholder={field.ph}
                            value={field.val}
                            onChange={(e) => field.set(e.target.value)}
                            className="inp"
                            style={{ ...inputStyle, paddingRight: 32 }}
                            min="0"
                            step="0.1"
                          />
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" style={{ fontSize: 10, color: 'var(--text3)', fontWeight: 700 }}>
                            {field.unit}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Row 3 — Kişisel bilgiler + Hesapla */}
                <div className="flex flex-wrap items-end gap-3">
                  <input type="text" placeholder="Adınız" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="inp" style={{ ...inputStyle, flex: '1 1 130px' }} />
                  <input type="text" placeholder="Soyadınız" value={lastName} onChange={(e) => setLastName(e.target.value)} className="inp" style={{ ...inputStyle, flex: '1 1 130px' }} />
                  <div className="relative" style={{ flex: '1 1 160px' }}>
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-sm font-semibold" style={{ color: 'var(--text3)' }}>+90</span>
                    <input type="tel" placeholder="5012345678" value={phone} onChange={(e) => setPhone(e.target.value)} className="inp" style={{ ...inputStyle, paddingLeft: 44 }} />
                  </div>
                  <input type="email" placeholder="e-posta" value={email} onChange={(e) => setEmail(e.target.value)} className="inp" style={{ ...inputStyle, flex: '1 1 180px' }} />

                  {result && (
                    <div
                      className="flex items-center gap-3 px-4 py-2.5 rounded-xl whitespace-nowrap"
                      style={{
                        background: 'rgba(232,97,26,0.1)',
                        border: '1.5px solid rgba(232,97,26,0.3)',
                        animation: 'slide-up 0.4s ease-out',
                      }}
                    >
                      <div>
                        <div style={{ fontSize: 10, color: 'var(--text3)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Tahmini</div>
                        <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--orange)', lineHeight: 1 }}>
                          {(result.price + result.vat).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺
                        </div>
                        <div style={{ fontSize: 10, color: 'var(--text3)' }}>KDV dahil</div>
                      </div>
                    </div>
                  )}

                  <button
                    onClick={handleCalculate}
                    disabled={!isValid || isLoading}
                    className="btn-primary whitespace-nowrap"
                    style={{
                      padding: '12px 28px',
                      opacity: isValid ? 1 : 0.45,
                      cursor: isValid ? 'pointer' : 'not-allowed',
                      flexShrink: 0,
                    }}
                  >
                    {isLoading
                      ? <><i className="ri-loader-4-line animate-spin"></i> Hesaplanıyor...</>
                      : <><i className="ri-calculator-line"></i> Hesapla</>
                    }
                  </button>
                </div>

              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
